<template>
  <div class="animated fadeIn">
    <div class="container">
      <div class="row pt-2">
        <div class="col-12 text-center">Bem vindo, <strong>{{ accountName }}</strong>!</div>
        <div class="col-12 text-center pt-3"><h3>Selecione a área desejada!</h3></div>
      </div>
      <div class="row pt-4 pb-4">
        <div class="col-12 text-center">
          <b-card-group deck>
            <b-card class="text-center pb-2 pointer" style="max-width: 20rem;" v-if="hasRole(this.roles.MENU_SINISTER)" @click="goToSinister">
              <i class="fa fa-file-text-o pt-4 text-third" style="font-size: 100px"></i>
              <h4 class="pt-3 text-default h4-title">Sinistros</h4>
              <div>Regulação de sinistros</div>
            </b-card>

            <b-card class="text-center pb-2 pointer" style="max-width: 20rem;" v-if="hasRole(this.roles.MENU_INSPECTION)" @click="goToCarInspection">
              <i class="fa fa-car pt-4 text-third" style="font-size: 100px"></i>
              <h4 class="pt-3 text-default h4-title">Vistoria</h4>
              <div>Vistoria de sinistros</div>
            </b-card>

            <b-card class="text-center pb-2 pointer" style="max-width: 20rem;" v-if="hasRole(this.roles.MENU_EXPERTROUTES)" @click="goToExpertRoutes">
              <i class="fa fa-map-signs pt-3 text-third" style="font-size: 100px"></i>
              <h4 class="pt-4 text-default h4-title">Roteirizador</h4>
              <div>Roteiro de vistoria</div>
            </b-card>

            <b-card class="text-center pb-2" style="max-width: 20rem;">
              <i class="fa fa-bar-chart pt-4 text-third" style="font-size: 100px"></i>
              <h4 class="pt-3 text-default h4-title">Relatórios</h4>
              <div>Geração de relatórios</div>
            </b-card>

            <b-card class="text-center pb-2 pointer" style="max-width: 20rem;" v-if="hasRole(this.roles.MENU_CONFIGURATION)" @click="goToSettings">
              <i class="fa fa-cogs pt-3 text-third" style="font-size: 100px"></i>
              <h4 class="pt-4 text-default h4-title">Configurações</h4>
              <div>Configurações do sistema</div>
            </b-card>
          </b-card-group>
        </div>
      </div>
      <div class="row pt-5">
        <div class="col-12 text-center">
          <img src="/static/img/bg/bg_features_overview_jg7a.svg" style="width: 60%; opacity: 0.5"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountMixin from '@/store/module/account/mixin'
import PermissionMixin from '@/store/module/permission/mixin'
import Tools from '@/components/tools/Tools.js'
import Roles from '@/shared/utils/roles.js'

export default {
  name: 'StartPage',
  mixins: [AccountMixin, PermissionMixin],
  data () {
    return {
      roles: Roles
    }
  },
  computed: {
    accountName: function () {
      var name = ''
      if (this.account && this.account.name) {
        name = Tools.capitalize(this.account.name.toLowerCase())
      }
      return name
    }
  },
  mounted () {
    // this.RemoveMinimizedSidebar()
  },
  methods: {
    RemoveMinimizedSidebar: function () {
      if (document.body.classList.length > 6) {
        document.body.classList.toggle('sidebar-minimized')
      }
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          if (this.permissions[i].role === role) {
            result = true
          }
        }
      }
      return result
    },
    goToSinister () {
      this.$router.push({ name: 'Regulacao' })
    },
    goToCarInspection () {
      this.$router.push({ name: 'Vistoria' })
    },
    goToExpertRoutes () {
      this.$router.push({ name: 'Roteirizador' })
    },
    goToSettings () {
      this.$router.push({ name: 'Configuracoes' })
    }
  }
}
</script>
<style scoped>
.card {
  border-radius: 11px;
  box-shadow: 0 0 1em #ccc;
}
.pointer {
  cursor: pointer;
}
.h4-title {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/views/private/StartPage.vue